/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import "./InterviewScreen.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircle,
} from "@fortawesome/free-solid-svg-icons";
import useInterviewScreenNew from "./useInterviewScreen";
import { Modal, Spinner } from "react-bootstrap";
import QuestionSubmitModal from "./_components/QuestionSubmitModal";
import QuestionDescription from "./_components/QuestionDescription";
import VideoProgress from "./_components/VideoProgress";

export default (props) => {
  const {
    videoElement,
    saveButtonRef,
    loading,
    question,
    timer,
    pageNum,
    videoUpload,
    uploadProgress,
    videoUploadMessage,
    endInterviewMessage,
    confirmModalOpen,
    confirmProgressModalOpen,
    nextEnabled,
    interviewCompleted,
    mode,
    fullScreenModalOpen,

    onNextClick,
    onEndInterviewClick,
    onConfirmEndInterviewClick,
    onCloseConfirmModal,
    onSaveQuestion,
    onCloseConfirmProgressModal,
    onPauseClick,
    onFullScreenClick
  } = useInterviewScreenNew(props);


  return (
    <div className={`interview-wrapper fullscreenchange`}>
      {videoUpload ? (
        <QuestionSubmitModal
          confirmProgressModalOpen={confirmProgressModalOpen}
          onCloseConfirmProgressModal={onCloseConfirmProgressModal}
          uploadProgress={uploadProgress}
          videoUploadMessage={videoUploadMessage}
          onNextClick={onNextClick}
          nextEnabled={nextEnabled}
          onPauseClick={onPauseClick}
        />
      ) : (
        <div className="new-interview-screen-wrapper">
          {loading ? (
            <div className="d-flex justify-content-center align-items-center mt-4">
              <Spinner
                animation="border"
                variant="primary"
                className="text-white"
              />
            </div>
          ) : (
            <div className={mode ? "d-none" : "d-block h-100"}>
              {interviewCompleted ? (
                <div className="d-flex align-items-center justify-content-center h-100">
                  <div className="mt-4 border rounded-lg p-4 text-center bg-grey">
                    <p className="container text-grey-4 font-weight-medium">
                      You have successfully completed this assessment kit.
                    </p>
                    <button
                      className="btn btn-primary ml-3 mt-3"
                      onClick={() => { onConfirmEndInterviewClick() }}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              ) : (
                <>
                  {" "}
                  <div className="container text-capitalize d-flex justify-content-between align-items-center flex-wrap">
                    <h2 className="font-weight-medium py-3 flex-1 mb-0">
                      Topic:{" "}
                      {question?.question_detail &&
                        question.question_detail?.topic_name}
                    </h2>
                    <VideoProgress
                      timer={timer}
                      question={question}
                      saveButtonRef={saveButtonRef}
                      onSaveQuestion={onSaveQuestion}
                      onEndInterviewClick={onEndInterviewClick}
                    />
                  </div>
                  <div className="container d-flex align-items-center mt-2">
                    <p className="font-weight-medium p-3 mr-3 d-inline-block rounded-lg border mb-0">
                      {question?.number_of_questions - question?.remaining_ques_count + 1}/{question?.number_of_questions}
                    </p>
                    <QuestionDescription
                      question={question}
                      pageNum={pageNum}
                      timer={timer}
                    />
                  </div>
                  <div className="position-relative mt-3">
                    <div className="video-container">
                      <video
                        id="player"
                        ref={videoElement}
                        autoPlay
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                        muted="muted"
                      ></video>
                      <span className="position-absolute text-white recording-icon bg-danger d-flex py-1 px-2 rounded-lg align-items-center">
                        <FontAwesomeIcon
                          icon={faCircle}
                          className="mr-2 fs-smallest"
                        />
                        Recording
                      </span>
                    </div>

                  </div>
                </>
              )}
            </div>
          )}


        </div>
      )}

      <Modal
        size="lg"
        show={confirmModalOpen}
        className="common-modal d-flex align-items-center"
        onHide={onCloseConfirmModal}
      >
        <Modal.Body className="pt-3">
          <span className="text-grey-4 fs-smallest">{endInterviewMessage}</span>
          <button
            className="btn btn-danger ml-3"
            onClick={() => onConfirmEndInterviewClick()}
          >
            End Interview
          </button>
          <button
            className="btn btn-primary ml-3"
            onClick={() => onCloseConfirmModal()}
          >
            Cancel
          </button>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        show={fullScreenModalOpen}
        className="common-modal d-flex align-items-center"
      >
        <Modal.Body className="p-3">
          <p className="my-2">Please go fullScreen mode to continue interview.</p>
          <div className="text-center pt-2">
            <button className="btn btn-primary" onClick={onFullScreenClick}>Full Screen Mode</button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};
